<script setup lang="ts">
import type {MenuItem} from '@/types/config';

import {createClasses} from '@/helpers/menu';

import MenuList from '@/components/menu/MenuList.vue';

defineProps<{
  classPrefix?: string;
  title?: string;
  items: MenuItem[];
}>();
</script>
<template>
  <nav
    v-if="items.length"
    :class="createClasses(['nav'], classPrefix)"
  >
    <h2
      v-if="title"
      :class="createClasses(['menu--title'], classPrefix)"
    >
      {{ title }}
    </h2>
    <MenuList
      :items="items || []"
      :class-prefix="classPrefix"
    />
  </nav>
</template>
